import localforage from 'localforage';
import { fetchRemoteAsset } from "../remoteAssets";

// pgw 29-oct-2025
let doprint = false;
// let doprint = true;


// ✅ Create a dedicated localforage instance for audio assets
const audioAssetStore = localforage.createInstance({
    name: 'multitrackPlayer',
    version: 1.0,
    storeName: 'audio_assets_store',
    description: 'Asset storage for the multitrackPlayer application'
});


// ✅ Explicitly async wrappers

export const getAssetItem = async (...args) => {
	if (doprint) console.log('getAssetItem args = ', args)
  return await audioAssetStore.getItem(...args);
};


export const setAssetItem = async (...args) => {
	if (doprint) console.log('setAssetItem args = ', args)
  return await audioAssetStore.setItem(...args);
};

export const removeAssetFromCache = async (...args) => {
	if (doprint) console.log('removeAssetFromCache args = ', args)
  return await audioAssetStore.removeItem(...args);
};


export const clearAudioStorage = async (...args) => {
	if (doprint) console.log('clearAudioStorage args = ', args)
  return await audioAssetStore.clear(...args);
};

/**
 * Fetches and returns an asset (arrayBuffer), optionally using cache.
 * @param {string} url - The URL or cache key.
 * @param {boolean} cache - Whether to cache the result.
 * @param {(percent: number) => void} onFetchProgress - Progress callback.
 * @returns {Promise<ArrayBuffer>}
 */

export const getAsset = async (url, cache = true, onFetchProgress = () => {}) => {
    onFetchProgress(0);

    if (!cache) {
        if (doprint) console.log('getAsset bypassing cache for url = ', url);

        const remoteResponse = await fetchRemoteAsset(url, onFetchProgress);
        return remoteResponse.data;
    }

	if (doprint) console.log('getAsset calling getAssetItem url = ', url)
    const cachedAsset = await getAssetItem(url);
    if (cachedAsset) {
        onFetchProgress(100);
        return cachedAsset;
    } else {
        const remoteResponse = await fetchRemoteAsset(url, onFetchProgress);
        const arrayBuffer = remoteResponse.data;

        if (cache) {
            await setAssetItem(url, arrayBuffer);
        }

        return arrayBuffer;
    }
};

